import { useState } from "react";
import config from "../config/config";
import Navbar from "../components/common/Navbar";
import "../styles/FeedbackPage.css";

function FeedbackForm() {
  const [experience, setExperience] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [issues, setIssues] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const [recommendation, setRecommendation] = useState(3);
  const [submitting, setSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const feedbackData = {
      experience,
      feedbackType,
      issues,
      suggestions,
      recommendation,
    };

    try {
      const response = await fetch(`${config.API_URL}/api/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(feedbackData),
      });

      if (response.ok) {
        setShowPopup(true);
        // Optionally clear form:
        setExperience("");
        setFeedbackType("");
        setIssues("");
        setSuggestions("");
        setRecommendation(3);
      } else {
        alert("Error submitting feedback.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Error submitting feedback.");
    }

    setSubmitting(false);
  };

  const handleEmojiClick = (emoji) => {
    setExperience(emoji);
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="feedback-container">
        <form onSubmit={handleSubmit} className="feedback-form">
          <h2 className="feedback-title">We'd Love Your Feedback!</h2>

          <label className="feedback-label">
            How was your overall experience using DotDash Academy? *
          </label>
          <div className="feedback-emojis">
            {["😡", "🥺", "😐", "😀", "😍"].map((emoji) => (
              <button
                key={emoji}
                type="button"
                onClick={() => handleEmojiClick(emoji)}
                className={`emoji-button ${
                  experience === emoji ? "selected" : ""
                }`}
              >
                {emoji}
              </button>
            ))}
          </div>

          <label className="feedback-label">
            What type of feedback is this? *
          </label>
          <select
            className="feedback-type"
            value={feedbackType}
            onChange={(e) => setFeedbackType(e.target.value)}
            required
          >
            <option value="">Select a category</option>
            <option value="bug">Bug Report</option>
            <option value="suggestion">Feature Request</option>
            <option value="uiux">UI/UX Feedback</option>
            <option value="general">General Comment</option>
          </select>

          <label className="feedback-label">
            Were there any difficulties or issues you encountered while using
            the website? *
          </label>
          <textarea
            className="feedback-issues"
            value={issues}
            onChange={(e) => setIssues(e.target.value)}
            required
          />

          <label className="feedback-label">
            What new features or improvements would you like to see in the
            future? *
          </label>
          <textarea
            className="feedback-suggestions"
            value={suggestions}
            onChange={(e) => setSuggestions(e.target.value)}
            required
          />

          <label className="feedback-label">
            How likely are you to recommend DotDash Academy to others? *
          </label>
          <input
            className="feedback-recommendation"
            type="number"
            value={recommendation}
            onChange={(e) => setRecommendation(e.target.value)}
            min="1"
            max="5"
            required
          />

          <button
            type="submit"
            className="feedback-submit-btn"
            disabled={submitting}
          >
            {submitting ? (
              <>
                <span className="feedbackSpinner" />
              </>
            ) : (
              "Submit Feedback"
            )}
          </button>
        </form>
        {showPopup && (
          <div
            className="feedback-popup-overlay"
            onClick={() => setShowPopup(false)}
          >
            <div
              className="feedback-popup"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="feedback-submitted-title">
                🎉 Feedback Submitted!
              </h3>
              <p className="feedback-submitted-text">
                Thank you for helping us improve DotDash Academy.
              </p>
              <button
                className="close-popup-btn"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FeedbackForm;
